// Column key → Korean label mapping (TL-1 migration from aiUtils.js).
// Backend availableFields description 미정의 시 fallback. show_display columnLabels 미명시 시 fallback.
// 50+ entries — name/phone/membership/date/sales/attendance/locker/merge 합성 필드 등 광범위.
export const LABEL_OVERRIDES = {
  name: '이름', memberName: '이름', userName: '이름', buyerName: '이름', teacherName: '이름',
  phone: '연락처', email: '이메일',
  memberShipName: '회원권', membershipName: '회원권', viewMembershipName: '회원권',
  endDate: '만료일', viewEndDate: '만료일', startDate: '시작일', viewStartDate: '시작일',
  statusName: '상태', reserveCount: '예약수', lessonName: '수업명',
  createdAt: '등록일', updatedAt: '수정일', birthDay: '생년월일', birthDate: '생년월일',
  totalCount: '총 인원', count: '건수', amount: '금액',
  price: '가격', totalPrice: '총 금액', paymentDate: '결제일', purchaseDate: '구매 날짜',
  coachName: '코치', className: '수업명', classTime: '수업시간',
  holdingStart: '홀딩시작', holdingEnd: '홀딩종료', reason: '사유',
  remainingDays: '남은일수',
  _count: '횟수',
  _lastDate: '마지막 방문일',
  _firstDate: '첫 방문일',
  weeklyFrequency: '주당 출석 빈도',
  lastVisit: '마지막 방문일',
  attendedCount: '출석 횟수',
  attendanceRate: '출석률',
  absentCount: '결석 횟수',
  reservationCount: '예약 횟수',
  remainCount: '잔여횟수', usedCount: '사용횟수',
  viewCount: '잔여횟수', viewRemainCount: '잔여횟수',
  viewUsedCount: '사용횟수', viewTotalCount: '총 횟수',
  memo: '메모', gender: '성별', age: '나이',
  // [1-R'] storeName 한국어 label 전역 fallback — 회원 detail intention 시 backend availableFields description이 'storeName' 그대로 (영문)라 priority 1 우회 → LABEL_OVERRIDES priority 2 사용 → '소속 지점'
  //   partner_gym intention은 backend description '센터명' priority 1에서 우선 사용 → 본 fallback 무영향
  storeName: '소속 지점',
  lockerName: '락커', lockerNumber: '락커번호',
  currentState: '현재 상태', totalUsageCount: '총 사용 횟수',
  point: '포인트', totalPoint: '총 포인트',
  expiringMemberships: '만료 회원권', memberships: '회원권 정보',
  activeMemberships: '이용중 회원권', expiredMemberships: '만료된 회원권',
  divisionName: '락커 분류명', state: '상태',
  // mergeSlots 합성 필드 (비교/시계열 stack) — LLM이 columnLabels 명시 안 한 경우 fallback
  period: '기간', periodStart: '시작일', periodEnd: '종료일',
  // 매출 컬럼 (백엔드 ai_intention 미등록 인텐션 fallback — SalesV1ApiNotes/ProductInfoV1ApiNotes 기준)
  originalPrice: '원가',
  notReceivedPrice: '미수금',
  paidPrice: '실결제액',
  cardPrice: '카드 결제액',
  cashPrice: '현금 결제액',
  discountPrice: '할인액',
  virtualBankPrice: '가상계좌 결제액',
  otherPrice: '기타 결제액',
  taxAmount: '부가세',
  // 매출 통계 컬럼 (CHECK_MEMBERSHIP+TOP+SALES_STATISTICS_BY+PERIOD 등 — augmentOutroWithChange/buildColumnLabels 공통)
  salesCount: '판매 건수',
  salesRevenue: '총 매출',
  totalSalesCount: '판매 건수',
  totalSalesRevenue: '총 매출',
  averagePrice: '평균 결제가',
  salesRate: '판매 점유율',
  // Cat11-RAW_CAMELCASE — 영문 camelCase/snake_case 필드 한국어 라벨 매핑
  hasAttendance: '출석 여부',
  teacherNames: '담당 강사',
  profile: '프로필',
  birthDay_group: '연령대',
  usageStartDate: '이용 시작일',
  usageEndDate: '이용 종료일',
  approvalDate: '승인일',
  storeId: '체육관 ID',
  isActive: '유효 여부',
  reservationOpenStandardTime: '예약 오픈 기준시간',
  reservationOpenTime: '예약 오픈 시간',
  reservationChangeTime: '예약 변경 가능 시간',
  reserveAvailableTime: '예약 가능 시간',
  holdingAvailableTime: '홀딩 가능 시간',
  isAutoAttendance: '자동 출석 여부',
  isUseAutoMessage: '자동 메시지 사용',
  isUseOneDayKakaoMessage: '당일 카카오 알림 사용',
  isViewReserveList: '예약 목록 노출',
  isViewReserveCount: '예약 인원 노출',
  isAvailableAttendanceInApp: '앱 출석 가능',
  isOpenTimeline: '타임라인 공개',
  isAvailableWeekendHolding: '주말 홀딩 가능',
  isUseNoShowPenalty: '노쇼 패널티 사용',
  isRegistBillingInfo: '결제 정보 등록',
  openingHour: '운영시간',
  // Cat11-RAW_CAMELCASE — 13차 baseline 추가 매핑 (회원 통계 / 시스템 설정 / 파트너짐)
  totalMembers: '총 회원수',
  activeMembers: '활성 회원수',
  activeRate: '활성률',
  avgAttendanceRate: '평균 출석률',
  avgWeeklyFrequency: '주평균 출석 빈도',
  noAttendanceMembers: '무출석 회원',
  nonDiscountPurchaseCount: '비할인 구매 건수',
  nonDiscountReRegistrationCount: '비할인 재등록 건수',
  isOnlyTodayOpenExercise: '오늘만 오픈 운동',
  maxReserveQueue: '대기 인원 최대',
  attendancePoint: '출석 포인트',
  isUseThreeDayKakaoMessage: '3일 카카오 알림 사용',
  isUseFiveDayKakaoMessage: '5일 카카오 알림 사용',
  isOpenPartnerGymSales: '제휴 체육관 판매',
  // [L31-COMPLEX-005] CHECK_MEMBER+MEMBERSHIP+HISTORY_LIST 백엔드가 available_fields 정의 외 raw camelCase로 노출하는 메타 필드
  //   — 정의 없으면 merged buffer에서 "{prefix}_alreadyMembershipCount" 형태 raw 라벨로 표 노출됨.
  //   show_display visualization-only guard가 1차 차단하지만 다른 merge 경로(non-MONTHLY base + HISTORY)에서는
  //   guard 우회 가능하므로 LABEL_OVERRIDES도 같이 등록해 fallback 보장.
  alreadyMembershipCount: '기존 회원권 수',
  // [14차 Cat6-RAW_CAMELCASE — 2026-05-30] SYN-CHECK_SYSTEM+SETTING_DETAIL-2 등에서 컬럼 헤더로 raw camelCase 노출
  //   isUseAttendancePoint / isUseConsecutiveAttendancePoint / isUseWorkoutCompletePoint — 출석 포인트 사용 여부 (시스템 설정)
  isUseAttendancePoint: '출석 포인트 사용',
  isUseConsecutiveAttendancePoint: '연속 출석 포인트 사용',
  isUseWorkoutCompletePoint: '운동 완료 포인트 사용',
  // SYN-CHECK_RESERVE+ATTENDANCE_STATISTICS류 — 요일별 통계 응답 컬럼 헤더 (백엔드 메타 미정의 fallback)
  //   attendanceRate는 이미 위에 '출석률'로 정의됨 (요일별/일반 양쪽 공용)
  dayOfWeek: '요일',
  totalSessions: '총 수업 횟수',
  totalReservations: '총 예약 건수',
  lateCount: '지각 건수',
  avgAttendedPerSession: '회당 평균 출석 인원',
};
